import { render } from "./RegisterHomeView.vue?vue&type=template&id=734abd90"
import script from "./RegisterHomeView.vue?vue&type=script&lang=js"
export * from "./RegisterHomeView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__